import styled from "styled-components";
import { Button as ButtonMaterialUI } from "@material-ui/core";

export const Button = styled(ButtonMaterialUI)`
  width: 100%;
  display: block;
  color: #ed5565;
  border-color: #ed5565;
`;
